#import "src/queries/fragments/personFragment.graphql"
#import "src/queries/fragments/personManagersTagsFragment.graphql"
#import "src/queries/fragments/personManagerFragment.graphql"
#import "src/queries/fragments/personCardFragment.graphql"
#import "src/queries/fragments/personFilledPositionsFragment.graphql"
#import "src/queries/fragments/accessGroupsFragment.graphql"
#import "src/comments/comments.graphql"

query getPersonWithOptionQuery(
  $aggregateId: String!
  $optionId: ID
  $includePositionFields: Boolean = false
  $includeOverlayAllAttributes: Boolean = false
) {
  person: getPersonWithOption(aggregateId: $aggregateId, optionId: $optionId) {
    ...PersonFragment
    ...PersonManagersTagsFragment
    allAttributes @include(if: $includeOverlayAllAttributes) {
      id
      attributeType
      subtype
      label
      value
    }
    customerEmployeeId
    disabled
    isVacancy
    filledPositions @include(if: $includePositionFields) {
      id
      name
      person {
        aggregateId
        preferredName
        firstName
        surname
        jobTitle
        avatar
        isVacancy
        tags: appliedTags {
          id
          tagId
          type
          displayValue
          isActive
          attributes
        }
        memberOf {
          id
          name
          type
          hierarchy
          hierarchyIds
        }
      }
    }
    memberOf {
      supplyOwners {
        aggregateId
      }
    }
    supplyOwnerOf {
      id
      name
      type
      hierarchy
      hierarchyIds
      parentIds
    }
    managing {
      ...PersonFragment
      ...PersonManagerFragment
      supplyOwnerOf {
        id
        name
        type
        hierarchy
        hierarchyIds
        parentIds
      }
    }
    supplyManaging {
      ...PersonFragment
      ...PersonManagerFragment
      supplyOwnerOf {
        id
        name
        type
        hierarchy
        hierarchyIds
        parentIds
      }
    }
  }
}
